import React from 'react';
import Icon from '../../../components/AppIcon';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';
import Button from '../../../components/ui/Button';

const OrganizationalStructure = ({ 
  structure, 
  onStructureChange, 
  onAddPosition, 
  onRemovePosition 
}) => {
  const departmentOptions = [
    { value: 'production', label: 'Produksi' },
    { value: 'quality', label: 'Kontrol Kualitas' },
    { value: 'supply', label: 'Manajemen Pasokan' },
    { value: 'finance', label: 'Keuangan' },
    { value: 'marketing', label: 'Pemasaran' },
    { value: 'hr', label: 'Sumber Daya Manusia' },
    { value: 'operations', label: 'Operasional' }
  ];

  const levelOptions = [
    { value: 'executive', label: 'Eksekutif (C-Level)' },
    { value: 'senior', label: 'Manajemen Senior' },
    { value: 'middle', label: 'Manajemen Menengah' },
    { value: 'supervisor', label: 'Supervisor' },
    { value: 'staff', label: 'Staf' }
  ];

  return (
    <div className="card">
      <div className="flex items-start justify-between mb-6">
        <div>
          <h2 className="text-2xl md:text-3xl font-semibold mb-2">Struktur Organisasi</h2>
          <p className="text-sm md:text-base text-muted-foreground">
            Petakan struktur organisasi dan jalur pelaporan untuk analisis kapasitas manajemen
          </p>
        </div>
        <div className="flex-shrink-0 w-12 h-12 md:w-14 md:h-14 rounded-xl bg-primary/10 flex items-center justify-center">
          <Icon name="Network" size={24} color="var(--color-primary)" />
        </div>
      </div>
      <div className="space-y-6">
        {structure?.positions?.map((position, index) => (
          <div key={position?.id} className="p-4 md:p-6 bg-muted/30 rounded-lg border border-border">
            <div className="flex items-center justify-between mb-4">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center">
                  <Icon name="User" size={20} color="var(--color-primary)" />
                </div>
                <span className="text-sm md:text-base font-medium">Posisi {index + 1}</span>
              </div>
              {structure?.positions?.length > 1 && (
                <Button
                  variant="ghost"
                  size="sm"
                  iconName="Trash2"
                  onClick={() => onRemovePosition(position?.id)}
                >
                  Hapus
                </Button>
              )}
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <Input
                label="Nama Posisi"
                placeholder="Contoh: Direktur Operasional"
                value={position?.title}
                onChange={(e) => onStructureChange(position?.id, 'title', e?.target?.value)}
                required
              />

              <Select
                label="Departemen"
                placeholder="Pilih departemen"
                options={departmentOptions}
                value={position?.department}
                onChange={(value) => onStructureChange(position?.id, 'department', value)}
                required
              />

              <Select
                label="Level Manajemen"
                placeholder="Pilih level"
                options={levelOptions}
                value={position?.level}
                onChange={(value) => onStructureChange(position?.id, 'level', value)}
                required
              />

              <Input
                label="Nama Pemegang Jabatan"
                placeholder="Nama lengkap"
                value={position?.holder}
                onChange={(e) => onStructureChange(position?.id, 'holder', e?.target?.value)}
                required
              />

              <Input
                label="Pengalaman (Tahun)"
                type="number"
                placeholder="0"
                min="0"
                value={position?.experience}
                onChange={(e) => onStructureChange(position?.id, 'experience', e?.target?.value)}
                required
              />

              <Input
                label="Jumlah Bawahan Langsung"
                type="number"
                placeholder="0"
                min="0"
                value={position?.directReports}
                onChange={(e) => onStructureChange(position?.id, 'directReports', e?.target?.value)}
                required
              />
            </div>

            <div className="mt-4">
              <Input
                label="Tanggung Jawab Utama"
                placeholder="Jelaskan tanggung jawab dan wewenang posisi ini"
                value={position?.responsibilities}
                onChange={(e) => onStructureChange(position?.id, 'responsibilities', e?.target?.value)}
                required
              />
            </div>
          </div>
        ))}

        <Button
          variant="outline"
          fullWidth
          iconName="Plus"
          iconPosition="left"
          onClick={onAddPosition}
        >
          Tambah Posisi
        </Button>
      </div>
      <div className="mt-6 p-4 bg-accent/10 rounded-lg border border-accent/20">
        <div className="flex items-start gap-3">
          <Icon name="Info" size={20} color="var(--color-accent)" className="flex-shrink-0 mt-0.5" />
          <div className="text-sm">
            <p className="font-medium text-accent-foreground mb-1">Panduan Pemetaan Struktur</p>
            <p className="text-muted-foreground">
              Sertakan semua posisi kunci dari level eksekutif hingga supervisor. Struktur organisasi yang jelas membantu identifikasi gap kapasitas untuk scale-up.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrganizationalStructure;